(() => {
  const initManualDownload = (section) => {
    if (section.dataset.manualDownloadReady === 'true') return;
    section.dataset.manualDownloadReady = 'true';

    const openButton = section.querySelector('[data-manual-dialog-open]');
    const closeButton = section.querySelector('[data-manual-dialog-close]');
    const dialog = section.querySelector('[data-manual-dialog]');

    if (!openButton || !closeButton || !dialog) return;

    const closeDialog = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    openButton.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-manual-download]').forEach(initManualDownload);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
